import Experience from './Experience/Experience.js'
import Landing    from './Landing.js'

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}))
}

const experience = new Experience(document.querySelector('canvas.webgl'))
const landing    = new Landing()

// ── Intro loader ──────────────────────────────────────────────────────────
const loaderEl      = document.getElementById('siteLoader')
const loaderBar     = document.getElementById('loaderBar')
const loaderPercent = document.getElementById('loaderPercent')
const _loaderT0     = performance.now()

let isReady = false // Прапорець реальної готовності ресурсів

const updateLoader = (ratio) => {
    const percentage = Math.round(ratio * 100)
    loaderBar.style.width = `${percentage}%`
    if (loaderPercent) loaderPercent.textContent = `${percentage}%`
}

// 1. Фейковий прогрес, який створює видимість активності
let fakeProgress = 0
const interval = setInterval(() => {
    // Рандомний крок від 1% до 4%
    fakeProgress += Math.random() * 0.04
    
    // Якщо ресурси вже готові (ready), ми дозволяємо прогресу йти до 100%
    if (isReady) {
        if (fakeProgress >= 1) {
            fakeProgress = 1
            clearInterval(interval)
            finishLoading()
        }
    } else {
        // Якщо ще не готові — зупиняємося на 90%
        if (fakeProgress >= 0.9) fakeProgress = 0.9
    }
    
    updateLoader(fakeProgress)
}, 60) // Частіший інтервал для плавності

// 2. Реальна подія готовності
experience.resources.on('ready', () => {
    isReady = true
    // Ми не викликаємо finishLoading тут, 
    // ми просто дозволяємо setInterval дійти до 100%
})

// 3. Фінальне приховування
function finishLoading() {
    const wait = Math.max(0, 1000 - (performance.now() - _loaderT0))
    setTimeout(() => {
        loaderEl.classList.add('hidden')
    }, wait)
}

// ── FORM EMAILS ──────────────────────────────────────────────────────────────

// 1. Ініціалізація (замість блоку в HTML)
if (window.emailjs) {
    emailjs.init(import.meta.env.VITE_EMAILJS_PUBLIC_KEY);
}

const accessForm = document.getElementById('accessForm');
const submitBtn = document.getElementById('submitBtn');

if (accessForm) {
    accessForm.addEventListener('submit', function(event) {
        event.preventDefault();

        const originalText = submitBtn.textContent;
        submitBtn.textContent = 'Sending...';
        submitBtn.disabled = true;

        // 2. Використання прихованих ID
        const serviceID = import.meta.env.VITE_EMAILJS_SERVICE_ID;
        const templateID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID;

        emailjs.sendForm(serviceID, templateID, this)
            .then(() => {
                submitBtn.textContent = 'Success!';
                accessForm.reset();

                setTimeout(() => {
                    submitBtn.textContent = originalText;
                    submitBtn.disabled = false;
                }, 3000);
            })
            .catch((err) => {
                submitBtn.textContent = 'Error';
                submitBtn.disabled = false;
                console.error('EmailJS Error:', err);
            });
    });
}

// ── Audio UI ──────────────────────────────────────────────────────────────
const fileInput      = document.getElementById('audioFileInput')
const tryDrop        = document.getElementById('tryDrop')
const audioPlayer    = document.getElementById('audioPlayer')
const playBtn        = document.getElementById('audioPlayBtn')
const trackEl        = document.getElementById('audioTrack')
const iconPlay       = playBtn.querySelector('.icon-play')
const iconPause      = playBtn.querySelector('.icon-pause')
const pills          = document.querySelectorAll('.pill[data-preset]')
const shapeBtns      = document.querySelectorAll('.shape-btn[data-shape]')
const scrubberEl     = document.getElementById('audioScrubber')
const scrubberFill   = document.getElementById('scrubberFill')
const scrubberThumb  = document.getElementById('scrubberThumb')
const portBtn        = document.getElementById('exportPortrait')
const landBtn        = document.getElementById('exportLandscape')
const squareBtn      = document.getElementById('exportSquare')
const exportMsgEl    = document.getElementById('exportMsg')

const analyser  = () => experience.world.audioAnalyser
const particles = () => experience.world.particleSystem
const exporter  = () => experience.world.videoExporter

function syncPlayIcon() {
    const playing = analyser().isPlaying
    iconPlay.style.display  = playing ? 'none' : ''
    iconPause.style.display = playing ? ''     : 'none'
}

function handleFile(file) {
    if (!file) return
    const isAudioMime = file.type.startsWith('audio/')
    const isAudioExt  = /\.(mp3|wav|flac|ogg|aac|m4a)$/i.test(file.name)
    if (!isAudioMime && !isAudioExt) return
    analyser().load(file)
}

// ── Scrubber ──────────────────────────────────────────────────────────────
let scrubDragging = false

function setScrubberPos(pct) {
    scrubberFill.style.width = `${pct * 100}%`
    scrubberThumb.style.left = `${pct * 100}%`
}

function seekFromPointer(clientX) {
    const rect = scrubberEl.getBoundingClientRect()
    const pct  = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width))
    analyser().seek(pct * analyser().duration)
    setScrubberPos(pct)
}

scrubberEl.addEventListener('mousedown',  (e) => { scrubDragging = true; seekFromPointer(e.clientX) })
scrubberEl.addEventListener('touchstart', (e) => { scrubDragging = true; seekFromPointer(e.touches[0].clientX) }, { passive: true })
document.addEventListener('mousemove',  (e) => { if (scrubDragging) seekFromPointer(e.clientX) })
document.addEventListener('touchmove',  (e) => { if (scrubDragging) seekFromPointer(e.touches[0].clientX) }, { passive: true })
document.addEventListener('mouseup',   () => { scrubDragging = false })
document.addEventListener('touchend',  () => { scrubDragging = false })

let scrubLoopStarted = false
function startScrubberLoop() {
    if (scrubLoopStarted) return
    scrubLoopStarted = true
    function tick() {
        if (!scrubDragging) {
            const a = analyser()
            if (a.duration > 0) setScrubberPos(a.currentTime / a.duration)
        }
        requestAnimationFrame(tick)
    }
    requestAnimationFrame(tick)
}

analyser().on('ready', (name) => {
    trackEl.textContent = name.replace(/\.[^.]+$/, '')
    audioPlayer.classList.add('visible')
    particles().activate()
    // Do not auto-play: on iOS source.start() must be in a direct user gesture task.
    // The Play button already has prewarm on touchstart and calls toggle() on click.
    syncPlayIcon()
    startScrubberLoop()
})

analyser().on('ended', () => {
    setScrubberPos(0)
    syncPlayIcon()
})

playBtn.addEventListener('click', () => {
    analyser().prewarm() // Додай сюди для гарантії на Android/Chrome
    analyser().toggle()
    syncPlayIcon()
})

// AudioContext must be created inside a direct user gesture.
// - iOS: `change` event from file-input is NOT a trusted activation → use touchstart
// - Chrome desktop: `change` event is also NOT trusted → use mousedown
// Both fire before the file picker opens / before the click resolves,
// so AudioContext is ready by the time load() or play() runs.
;[tryDrop, document.getElementById('audioChangeBtn'), playBtn].forEach(el => {
    if (!el) return
    el.addEventListener('touchstart', () => analyser().prewarm(), { passive: true })
    el.addEventListener('mousedown',  () => analyser().prewarm())
})

// Export buttons: prewarm AudioContext AND the offscreen WebGL renderer.
portBtn?.addEventListener('touchstart',   () => { analyser().prewarm(); exporter().prewarm('9x16') }, { passive: true })
landBtn?.addEventListener('touchstart',   () => { analyser().prewarm(); exporter().prewarm('16x9') }, { passive: true })
squareBtn?.addEventListener('touchstart', () => { analyser().prewarm(); exporter().prewarm('1x1')  }, { passive: true })

fileInput.addEventListener('change', (e) => handleFile(e.target.files[0]))
document.getElementById('audioFileInput2').addEventListener('change', (e) => {
    handleFile(e.target.files[0])
    e.target.value = ''
})

tryDrop.addEventListener('dragover',  (e) => { e.preventDefault(); tryDrop.classList.add('dragover') })
tryDrop.addEventListener('dragleave', ()  => tryDrop.classList.remove('dragover'))
tryDrop.addEventListener('drop', (e) => {
    e.preventDefault()
    tryDrop.classList.remove('dragover')
    handleFile(e.dataTransfer.files[0])
})

pills.forEach(pill => {
    pill.addEventListener('click', () => {
        pills.forEach(p => p.classList.remove('active'))
        pill.classList.add('active')
        particles().setPreset(pill.dataset.preset)
    })
})

document.querySelectorAll('.preset-card[data-preset]').forEach(card => {
    card.addEventListener('click', () => {
        window.location.href = '/app?preset=' + card.dataset.preset
    })
})

shapeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
        shapeBtns.forEach(b => b.classList.remove('active'))
        btn.classList.add('active')
        particles().morphTo(parseInt(btn.dataset.shape))
    })
})

// ── Export UI ─────────────────────────────────────────────────────────────
let _exportMsgTimer = null

function setExportPending(on) {
    portBtn?.classList.toggle('pending', on)
    landBtn?.classList.toggle('pending', on)
    squareBtn?.classList.toggle('pending', on)
}

function showExportMsg(msg, durationMs = 4000) {
    if (!exportMsgEl) return
    exportMsgEl.textContent = msg
    exportMsgEl.classList.add('visible')
    clearTimeout(_exportMsgTimer)
    _exportMsgTimer = setTimeout(() => exportMsgEl.classList.remove('visible'), durationMs)
}

const isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0)

async function triggerExport(format) {
    if (isTouch || exporter().isRecording || window._pendingExportFormat) return

    const email = await ensureEmail()
    if (!email) return

    setExportPending(true)

    const check = await exporter().checkExportAllowed(format)
    if (!check.allowed) {
        setExportPending(false)
        showExportMsg(check.error)
        return
    }

    // Store session so _finalize() can log the export
    exporter()._exportSession = check.session

    // Turnstile only for authenticated users — email-only users start directly
    if (check.session && typeof turnstile !== 'undefined') {
        window._pendingExportFormat = format
        turnstile.reset('#turnstile-container')
        turnstile.execute('#turnstile-container')
    } else {
        setExportPending(false)
        exporter().startRecording(format)
    }
}

portBtn?.addEventListener('click',   () => triggerExport('9x16'))
landBtn?.addEventListener('click',   () => triggerExport('16x9'))
squareBtn?.addEventListener('click', () => triggerExport('1x1'))

// ── Turnstile callbacks (global, called by Cloudflare CDN script) ─────────
window.onTurnstileSuccess = (token) => {
    const format = window._pendingExportFormat
    window._pendingExportFormat = null
    setExportPending(false)
    if (format) exporter().startRecording(format)
}

window.onTurnstileError = () => {
    window._pendingExportFormat = null
    setExportPending(false)
    showExportMsg('Challenge failed — please try again')
}

// ── Email modal ───────────────────────────────────────────────────────────────
const emailModalOverlay = document.getElementById('emailModalOverlay')
const emailModalInput   = document.getElementById('emailModalInput')
const emailModalSubmit  = document.getElementById('emailModalSubmit')
const emailModalCancel  = document.getElementById('emailModalCancel')

function ensureEmail() {
    const stored = localStorage.getItem('vyzflow_email')
    if (stored) return Promise.resolve(stored)

    return new Promise(resolve => {
        emailModalInput.value = ''
        emailModalInput.classList.remove('email-modal-input--error')
        emailModalOverlay.hidden = false
        emailModalInput.focus()

        const onSubmit = () => {
            const val = emailModalInput.value.trim()
            if (!val || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
                emailModalInput.classList.add('email-modal-input--error')
                setTimeout(() => emailModalInput.classList.remove('email-modal-input--error'), 800)
                return
            }
            localStorage.setItem('vyzflow_email', val)
            emailModalOverlay.hidden = true
            cleanup()
            resolve(val)
        }
        const onCancel = () => {
            emailModalOverlay.hidden = true
            cleanup()
            resolve(null)
        }
        const onKey = (e) => {
            if (e.key === 'Enter')  onSubmit()
            if (e.key === 'Escape') onCancel()
        }
        const onBackdrop = (e) => { if (e.target === emailModalOverlay) onCancel() }

        const cleanup = () => {
            emailModalSubmit.removeEventListener('click', onSubmit)
            emailModalCancel.removeEventListener('click', onCancel)
            emailModalInput.removeEventListener('keydown', onKey)
            emailModalOverlay.removeEventListener('click', onBackdrop)
        }

        emailModalSubmit.addEventListener('click', onSubmit)
        emailModalCancel.addEventListener('click', onCancel)
        emailModalInput.addEventListener('keydown', onKey)
        emailModalOverlay.addEventListener('click', onBackdrop)
    })
}
